var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79835 15.9003L5.59869 11.6999L4.19858 13.0998L9.79812 18.7003L21.7991 6.70125L20.3992 5.30113L9.79835 15.9003Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone24Px);
export default __webpack_public_path__ + "static/media/done_24px.89f7fa86942720017fbbc67a170a9eb3.svg";
export { ForwardRef as ReactComponent };